import identifyUser from './identifyUser';
import logEvent from './logEvent';

export { identifyUser, logEvent };
